import Link from 'next/link'
import type { ServiceCardData } from './types'

export function ServiceCard({ service }: { service: ServiceCardData }) {
  return (
    <Link href={`/services/${service.slug}`} className="svc-card">
      <div className="svc-card-img">
        {service.image ? (
          <img src={service.image} alt={service.name} />
        ) : (
          <div className="svc-card-placeholder" style={{ background: `${service.categoryColor}1a` }}>
            <span className="svc-card-placeholder-icon" style={{ color: service.categoryColor }}>
              {service.categoryIcon}
            </span>
          </div>
        )}
        <span className="svc-card-tag" style={{ background: service.categoryColor }}>
          {service.categoryName}
        </span>
      </div>
      <div className="svc-card-body">
        <div className="svc-card-name">{service.name}</div>
        {(service.clusterName || service.address) && (
          <div className="svc-card-loc">📍 {service.clusterName ?? service.address}</div>
        )}
        {service.phone && <div className="svc-card-meta">☎ {service.phone}</div>}
        {service.workingHours && <div className="svc-card-meta">🕐 {service.workingHours}</div>}
        <span className="svc-card-cta">View details →</span>
      </div>
    </Link>
  )
}
